
  <ion-card-header color= 'primary'>
    <ion-card-subtitle style="color: whitesmoke;">Seleccione una</ion-card-subtitle>
    <ion-card-title style="color: whitesmoke;">Sus empresas Fitosanitarias:</ion-card-title>

  </ion-card-header>
<ion-content>
<ion-list>
  <div *ngFor="let empresa of listado">
  <ion-item  (click)='empresaSeleccionada(empresa)'>
    <ion-avatar style="margin-top: 0px;" slot="start">
      <div class="redondel">
        <ion-note class="diaGrandeAgenda"><strong>{{empresa?.Nombre.substr(0,1)}}</strong></ion-note>
      </div>
    </ion-avatar>
    <ion-label id="nombre_incidencia"><strong>{{empresa?.Nombre}}</strong></ion-label>
    
  </ion-item>
</div>
</ion-list>
</ion-content>

